import React from "react";
import { Select, Typography } from "antd";
import { withTranslation } from "react-i18next";

import { SingleSelect } from "../customComponent/CustomSelect";
import { ALL, NOT_DONE, DONE } from "../../constant/filters";

const { Option } = Select;
const { Text } = Typography;

const StatusPreFix = ({ t }) => <Text style={{ color: "#9B9B9B" }}>{t("filter.status.label")}:</Text>;

const TaskStatusFilterComponent = ({ t, value, onSelect, dataTMId }) => {
  return (
    <SingleSelect value={value} onSelect={onSelect} dataTMId={dataTMId}>
      <Option value={ALL}>
        <StatusPreFix t={t} /> {t("all")}
      </Option>
      <Option value={DONE}>
        <StatusPreFix t={t} /> {t("filter.status.done")}
      </Option>
      <Option value={NOT_DONE}>
        <StatusPreFix t={t} /> {t("filter.status.not_done")}
      </Option>
    </SingleSelect>
  );
};
const TaskStatusFilter = withTranslation()(TaskStatusFilterComponent);

export { TaskStatusFilter };
